import { apiRequest } from "../utils";

export type APIDriveStatus = {
  enabled: boolean;
  running: boolean;
  lastRun?: { finishedAt: number; error?: string };
  folderUrl?: string;
  sheetUrl?: string;
};

function authHeaders() {
  const token = localStorage.getItem("token");
  return { headers: { Authorization: `Bearer ${token}` } };
}

export async function getDriveStatus(): Promise<APIDriveStatus> {
  const response = await apiRequest.get("/setup/drive/status", authHeaders());
  return response.data;
}

// Copies photos still stored on the server, every proposal PDF, and the
// customer sheet to Google Drive. Runs in the background on the server.
export async function copyAllToDrive(): Promise<void> {
  await apiRequest.post("/setup/drive/copy", {}, authHeaders());
}
